(function() {
  'use strict';

//app constructor: appname, dependecies array
  angular
    .module('mysite', ['ngSanitize',
                        'ngAria',
                        'ngResource',
                        'ui.router',
                        'ngMaterial',
                        'toastr',
                        'minimalPiechart',
                        'ngMaterial',
                        'ngMessages',
                        'angular-meter-polyfill',
                        'angular-timeline',
                        'angular-scroll-animate',
                        'ngMap',
                        'ng.deviceDetector']);

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myWork', myWork);

  /** @ngInject */
  function myWork() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/work/work.html',
      scope: {
        creationDate: '='
      },
      controller: WorkController,
      controllerAs: 'w',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function WorkController($window) {
      var w = this;

      w.events = [{
        badgeClass: 'work work-1',
        badgeIconClass: 'work',
        title: 'Web integrator / UI designer consultant',
        subtitle: 'Alten - France',
        content: 'Restyling and creation by scratch of graphic design of UIs, thinking about the User Experience and the possible technical issues . Using of the Material Design guidelines provided by Google. Create functional web pages using HTML5 and CSS3 starting from the mockups. Cross browser and cross device development'
      }, {
        badgeClass: 'work work-2',
        badgeIconClass: 'work',
        title: 'Frontend developer',
        subtitle: 'Bitmama - Italy',
        content: 'Client side development and management on web portals in the automotive sector (Fiat, Lancia) for several European markets. Use of Microsoft SharePoint CMS, version control SVN and cross browser development using HTML5, CSS3 and Javascript (with JQuery and AJAX).'
      }, {
        badgeClass: 'work work-3',
        badgeIconClass: 'computer',
        title: 'Intern for Master Thesis',
        subtitle: 'Eurecom Telecom Paris Tech - France',
        content: 'Design and development of HyperTED: a web application able to browse and search through Media Fragments of TED Talks recommending related contents according to semantic entities extracted in the subtitles.'
      }];

      var mq = $window.matchMedia( "(min-width: 500px)" );
      if(mq){
            w.animateElementIn = function($el) {
              $el.removeClass('timeline-hidden');
              $el.addClass('bounce-in'); // this example leverages animate.css classes
          };
      }

    }
  }



})();

(function() {
  'use strict';

  angular
      .module('mysite')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Stylus',
        'url': 'http://learnboost.github.io/stylus/',
        'description': 'Stylus is a revolutionary new language, providing an efficient, dynamic, and expressive way to generate CSS. Supporting both an indented syntax and regular CSS style.',
        'logo': 'stylus.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('mySkills', mySkills);

  /** @ngInject */
  function mySkills() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/skills/skills.html',
      scope: {
          creationDate: '='
      },
      controller: SkillsController,
      controllerAs: 'sk',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SkillsController() {
    //  var sk = this;

        this.animateElementIn = function($el) {
          $el.removeClass('timeline-hidden');
          $el.addClass('animated fadeInUp'); // this example leverages animate.css classes
          };
        
      }
  }
})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myQuote', myQuote);

  /** @ngInject */
  function myQuote() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/quote/quote.html',
      scope: {
          creationDate: '='
      },
      controller: QuoteController,
      controllerAs: 'qu',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function QuoteController() {

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myPresentation', myPresentation);

  /** @ngInject */
  function myPresentation() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/presentation/presentation.html',
      scope: {
        creationDate: '='
      },
      controller: PresentationController,
      controllerAs: 'pr',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function PresentationController() {
      var pr = this;

      pr.imagePath = '../assets/images/me.jpg';
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myNav', myNav);

  /** @ngInject */
  function myNav() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: AppCtrl,
      controllerAs: 'nav',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AppCtrl($scope) {
      $scope.currentNavItem = 'home';
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myHome', myHome);

  /** @ngInject */
  function myHome() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/home/home.html',
      scope: {
          creationDate: '='
      },
      controller: HomeController,
      controllerAs: 'mh',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HomeController() {
      var mh = this;

      angular.element(document).ready(function(){
        mh.images= ['../assets/images/bg/bg_1.jpg', '../assets/images/bg/bg_2.jpg', '../assets/images/bg/bg_3.jpg', '../assets/images/bg/bg_4.jpg', '../assets/images/bg/bg_5.jpg', '../assets/images/bg/bg_6.jpg', '../assets/images/bg/bg_7.jpg', '../assets/images/bg/bg_8.jpg'];
        mh.randomIndex = Math.floor(Math.random() * mh.images.length);
        mh.classToAdd = mh.images[mh.randomIndex];

});

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myEducation', myEducation);

  /** @ngInject */
  function myEducation() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/education/education.html',
      scope: {
        creationDate: '='
      },
      controller: EducationController,
      controllerAs: 'ed',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function EducationController() {
      var ed = this;

      ed.events = [{
        badgeClass: 'education education-1',
        badgeIconClass: 'school',
        title: 'Cinema and Media Engineering Master Degree',
        subtitle: 'March 2015',
        content: 'Politecnico di Torino - Torino, Italy'

      },{
        badgeClass: 'education education-2',
        badgeIconClass: 'school',
        title: 'Erasmus',
        subtitle: 'April - September 2014',
        content: 'Eurecom Telecom Paris Tech - Sophia Antipolis, France'
      }, {
        badgeClass: 'education education-3',
        badgeIconClass: 'school',
        title: 'Cinema and Media Engineering Bachelor\'s Degree',
        subtitle: 'September 2012',
        content: 'Politecnico di Torino - Torino, Italy'
      }, {
        badgeClass: 'education education-4',
        badgeIconClass: 'school',
        title: 'Classical High School Diploma',
        subtitle: '2008',
        content: 'Liceo Classico D\'Adda - Varallo (VC), Italy'
      }];

      ed.animateElementIn = function($el) {
        $el.removeClass('timeline-hidden');
        $el.addClass('bounce-in'); // this example leverages animate.css classes
    };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .directive('myContacts', myContacts);

  /** @ngInject */
  function myContacts() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/contacts/contacts.html',
      scope: {
        creationDate: '='
      },
      controller: ContactsController,
      controllerAs: 'c',
      bindToController: true
    };

    return directive;
}
    /** @ngInject */
    function ContactsController($scope, NgMap, NavigatorGeolocation, GeoCoder) {
      NgMap.getMap("map").then(function () {
        GeoCoder.geocode({ address: 'Place Massena, Nice' })
        .then(function () {
          $scope.mapCenter = [43.7101728, 7.2619532];
        });
      });
      $scope.googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDV-wgCPF8UIrj7SkwEHV_nL_wX9oWZGaM&callback=initMap";
      $scope.mapCenter = [43.7101728, 7.2619532];
    }


})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1469368529468;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('work', {
        url: '/#work',
        templateUrl: 'app/main/main.html#work',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/');
  }



})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('mysite')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('mysite')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("mysite").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div layout=vertical layout-fill><md-content><header><!-- <my-nav></my-nav> --></header><section class=section id=home><my-home></my-home></section><section class=section id=quote><my-quote></my-quote></section><section class=section id=presentation><my-presentation></my-presentation></section><section class=section id=skills><my-skills></my-skills></section><section class=section id=work><my-work></my-work></section><section class=section id=education><my-education></my-education></section><section class=section id=contacts><my-contacts></my-contacts></section><footer><p>© Mariella Sabatino, 2016. v. 1.0.1</p></footer></md-content></div>");
$templateCache.put("app/components/contacts/contacts.html","<h1 class=title>Contacts</h1><div class=contacts__container><div class=contacts__map><ng-map id=map center={{mapCenter}} default-style=false zoom=10><marker position={{mapCenter}} title=marker animation=Animation.DROP></marker></ng-map></div><div layout=row layout-align=\"space-around center\" layout-margin><div class=contacts__links><div layout=column layout-align=center><div layout=row layout-align=\"space-between center\"><md-button href=mailto:mll.sabatino@gmail.com target=_blank class=\"md-icon-button social_logo\" aria-label=email><i class=material-icons>email</i></md-button><label><a href=mailto:mll.sabatino@gmail.com target=_blank>mll.sabatino@gmail.com</a></label></div><div layout=row layout-align=\"space-between center\"><md-button href=tel:0033665132555 class=\"md-icon-button social_logo\" aria-label=phone><i class=material-icons>phone_android</i></md-button><div class=contacts-links__half><label><a href=tel:0033665132555>+33 (0) 6 65 13 25 55</a></label></div></div><div layout=row layout-align=\"space-between center\"><md-button href=/ class=\"md-icon-button social_logo\" aria-label=webpage><i class=material-icons>language</i></md-button><div class=contacts-links__half><label><a href=/ >https://marsab.github.io/</a></label></div></div><div layout=row layout-align=\"space-between center\"><md-button href=skype:mellasab8?call class=\"md-icon-button social_logo\" aria-label=skype><md-icon md-svg-icon=../assets/images/social/skype.svg class=material-icons></md-icon></md-button><div class=contacts-links__half><label><a href=skype:mellasab8?call>mellasab8</a></label></div></div></div></div><div class=contacts__social><div layout=column layout-align=center><div layout=row layout-align=\"space-between center\"><md-button href=https://github.com/MarSab target=_blank class=\"md-icon-button social_logo\" aria-label=github><md-icon md-svg-icon=../assets/images/social/github-logo.svg></md-icon></md-button><label><a href=https://github.com/MarSab target=_blank>/MarSab</a></label></div><div layout=row layout-align=\"space-between center\"><md-button href=https://www.linkedin.com/in/mariellasabatino target=_blank class=\"md-icon-button social_logo\" aria-label=linkedin><md-icon md-svg-icon=../assets/images/social/linkedin.svg></md-icon></md-button><label><a href=https://www.linkedin.com/in/mariellasabatino target=_blank>/mariellasabatino</a></label></div><div layout=row layout-align=\"space-between center\"><md-button href=https://www.instagram.com/marsab8/ target=_blank class=\"md-icon-button social_logo\" aria-label=instagram><md-icon md-svg-icon=../assets/images/social/instagram.svg></md-icon></md-button><label><a href=https://www.instagram.com/marsab8/ target=_blank>/marsab8</a></label></div><div layout=row layout-align=\"space-between center\"><md-button href=http://www.slideshare.net/MariellaSabatino target=_blank class=\"md-icon-button social_logo\" aria-label=Slideshare><md-icon md-svg-icon=../assets/images/social/slideshare-logo.svg></md-icon></md-button><label><a href=http://www.slideshare.net/MariellaSabatino target=_blank>/MariellaSabatino</a></label></div></div></div></div></div>");
$templateCache.put("app/components/education/education.html","<h1 class=\"title title--right\">What did I study?</h1><timeline><timeline-event ng-repeat=\"event in ed.events\" side=alternate class={{event.badgeClass}}><timeline-badge class={{event.badgeClass}}><i class=\"material-icons icon-white\">{{event.badgeIconClass}}</i></timeline-badge><timeline-panel class={{event.badgeClass}} when-visible=ed.animateElementIn class=timeline-hidden><timeline-heading><h4 class=\"subtitle subtitle--orange subtitle--timeline\">{{event.title}}</h4><h5>{{event.subtitle}}</h5></timeline-heading><p>{{event.content}}</p></timeline-panel></timeline-event></timeline>");
$templateCache.put("app/components/home/home.html","<div class=home_container><div class=container__logo><img src=../assets/images/mylogo.svg alt=logo></div><div class=container__text><h1 class=title>Mariella Sabatino</h1><h3 class=\"subtitle subtitle--basic\">Frontend web engineer and designer</h3></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=row layout-align=\"center center\"><md-nav-bar md-selected-nav-item=currentNavItem nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=/#home name=home>home</md-nav-item><md-nav-item md-nav-click=#presentation name=about>about</md-nav-item><md-nav-item md-nav-click=#skills name=skills>skills</md-nav-item><md-nav-item md-nav-click=/#work name=work>work</md-nav-item><md-nav-item md-nav-click=#education name=education>education</md-nav-item><md-nav-item md-nav-click=#contacts name=contacts>contacts</md-nav-item><!-- these require actual routing with ui-router or ng-route, so they won\'t work in the demo\n        <md-nav-item md-nav-sref=\"app.page4\" name=\"page4\">Page Four</md-nav-item>\n        <md-nav-item md-nav-href=\"#page5\" name=\"page5\">Page Five</md-nav-item>\n        --></md-nav-bar></md-toolbar>");
$templateCache.put("app/components/presentation/presentation.html","<div class=presentation__container><md-card class=presentation__idCard><img ng-src={{pr.imagePath}} class=md-card-image alt=\"Mariella Sabatino picture\"><md-card-content flex layout-align=\"center center\"><div class=id_card><div class=id_card__row><div class=\"id_card__half id_card__half--icon\"><i class=material-icons>cake</i></div><div class=id_card__half><h4>28 / 12 / 1989</h4></div></div><div class=id_card__row><div class=\"id_card__half id_card__half--icon\"><i class=material-icons>place</i></div><div class=id_card__half><h4>Nice, France</h4></div></div><div class=id_card__row><div class=\"id_card__half id_card__half--icon\"><a href=mailto:mll.sabatino@gmail.com target=_blank><i class=material-icons>email</i></a></div><div class=id_card__half><h4><a href=mailto:mll.sabatino@gmail.com target=_blank>mll.sabatino@gmail.com</a></h4></div></div><div class=id_card__row><div class=\"id_card__half id_card__half--icon\"><a href=tel:0033665132555><i class=material-icons>phone_android</i></a></div><div class=id_card__half><h4><a href=tel:0033665132555>+33 (0) 6 65 13 25 55</a></h4></div></div></div></md-card-content><md-card-actions layout=row layout-align=center><md-button href=https://github.com/MarSab target=_blank class=\"md-icon-button social_logo\" aria-label=github><md-icon md-svg-icon=../assets/images/social/github-logo.svg></md-icon></md-button><md-button href=https://www.linkedin.com/in/mariellasabatino target=_blank class=\"md-icon-button social_logo\" aria-label=linkedin><md-icon md-svg-icon=../assets/images/social/linkedin.svg></md-icon></md-button><md-button href=https://www.instagram.com/marsab8/ target=_blank class=\"md-icon-button social_logo\" aria-label=instagram><md-icon md-svg-icon=../assets/images/social/instagram.svg></md-icon></md-button><md-button href=http://www.slideshare.net/MariellaSabatino target=_blank class=\"md-icon-button social_logo\" aria-label=Slideshare><md-icon md-svg-icon=../assets/images/social/slideshare-logo.svg></md-icon></md-button></md-card-actions></md-card><div class=presentation__about><h3 class=\"subtitle subtitle--orange subtitle--margin\">Who am I?</h3><p>Strongly passionate of User Interaction, User Interfaces and pixel perfection, I love to design and build Web applications that fit perfectly on any device using Responsive Web Design. I always try to find the best and most durable solution. Speaking three languages, I love to work in an international environment: after my Erasmus experience, I have learnt the importance of that as a personal and professional growth engine.</p><h3 class=\"subtitle subtitle--orange\">my interests?</h3><div class=presentation__about--interests><i class=\"material-icons interest\">camera_alt<md-tooltip>Photography</md-tooltip></i><i class=\"material-icons interest\">airplanemode_active<md-tooltip>Travel</md-tooltip></i><i class=\"material-icons interest\">directions_run<md-tooltip>Sport</md-tooltip></i><i class=\"material-icons interest\">restaurant_menu<md-tooltip>Cook</md-tooltip></i></div></div></div>");
$templateCache.put("app/components/quote/quote.html","<h1 class=title>\"make the web a better place\"</h1>");
$templateCache.put("app/components/skills/skills.html","<h1 class=\"title title--right\">What can I do?</h1><md-card class=\"tech_skills__card skills__card timeline-hidden\" when-visible=sk.animateElementIn device-detector><div class=tech_skills__container><div class=tech_skills__block><div class=tech_skills__block--row><h2 class=\"subtitle subtitle--orange\">Technical stuff</h2></div><div class=tech_skills__block--row><div class=meter-inner-element><div class=meter-bar><div class=\"meter-optimum-value width-95\"></div></div></div><label>HTML5 - CSS3 - Sass - Webstorm/Atom</label></div><div class=tech_skills__block--row><div class=meter-inner-element><div class=meter-bar><div class=\"meter-optimum-value width-80\"></div></div></div><label>Git - Gulp - jQuery - JS</label></div><div class=tech_skills__block--row><div class=meter-inner-element><div class=meter-bar><div class=\"meter-optimum-value width-30\"></div></div></div><label>NodeJs - AngularJs - Mongodb</label></div></div><div class=tech_skills__block><div class=tech_skills__block--row><h2 class=\"subtitle subtitle--orange subtitle--margin\">Design & graphics</h2></div><div class=tech_skills__block--row><div class=meter-inner-element><div class=meter-bar><div class=\"meter-optimum-value width-80\"></div></div></div><label>Photoshop - Illustrator - Balsamiq - SVG - RWD - Material Design - Bootstrap - Foundation</label></div><div class=tech_skills__block--row><div class=meter-inner-element><div class=meter-bar><div class=\"meter-optimum-value width-60\"></div></div></div><label>video editing - premiere - motion design - after effects</label></div></div><div class=tech_skills__block><div class=tech_skills__block--row><h2 class=\"subtitle subtitle--orange subtitle--margin\">Communication</h2></div><div class=tech_skills__block--row><div class=meter-inner-element><div class=meter-bar><div class=\"meter-optimum-value width-60\"></div></div></div><label>UX design - Ergonomy and Usability</label></div></div></div></md-card><div class=skills__box><md-card class=\"skills__card timeline-hidden\" when-visible=sk.animateElementIn><md-card-title><md-card-title-text><span class=\"md-headline subtitle subtitle--orange\">Talk with me</span></md-card-title-text></md-card-title><div class=skills__card--lang><div class=lang_container><donutchart value=101></donutchart><label class=lang--text>IT</label></div><div class=lang_container><donutchart value=90></donutchart><label class=lang--text>EN</label></div><div class=lang_container><donutchart value=80></donutchart><label class=lang--text>FR</label></div></div></md-card><md-card class=\"skills__card timeline-hidden\" when-visible=sk.animateElementIn><md-card-title class=title--noflex><md-card-title-text><span class=\"md-headline subtitle subtitle--orange\">Personal skills</span></md-card-title-text></md-card-title><div class=skills__card--pers><label>creativity - team worker - fast learner - flexibility - can do attitude - problem solving - adaptability - desire to learn - detail oriented - pixel picky</label></div></md-card></div>");
$templateCache.put("app/components/work/work.html","<h1 class=\"title title--right\">What did I do?</h1><timeline><timeline-event ng-repeat=\"event in w.events\" side=alternate class={{event.badgeClass}}><timeline-badge class={{event.badgeClass}}><i class=\"material-icons icon-white\">{{event.badgeIconClass}}</i></timeline-badge><timeline-panel class={{event.badgeClass}} when-visible=w.animateElementIn class=timeline-hidden><timeline-heading><h4 class=\"subtitle subtitle--timeline\">{{event.title}}</h4><h5>{{event.subtitle}}</h5></timeline-heading><p>{{event.content}}</p></timeline-panel></timeline-event></timeline>");}]);